import { UpdateStatusEffectHandlers, useUpdateStatusEffect } from 'hooks';
import { getDialogStatus } from 'state/AccountTree';

export function usePageDialogStatusEffect(
  handlers: UpdateStatusEffectHandlers
) {
  useUpdateStatusEffect(getDialogStatus, handlers);
}
